export default __webpack_public_path__ + "static/media/Thumb_Facial_Hair_06.45fa5230.png";